import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import DataTypeApi from '../api/data_type/data_type.ts';

export const fetchDataTypeAsync = createAsyncThunk(
    'dataType/fetchDataType',
    async () => {
        const response = await DataTypeApi();
        return response;
    }
);

const dataTypeSlice = createSlice({
    name: 'dataType',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchDataTypeAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchDataTypeAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(fetchDataTypeAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    },
});

export default dataTypeSlice.reducer;